<script setup lang="ts">
import { useRouter } from 'vue-router';

import {
  CESSION_CATEGORY_COLOR_CLASS,
  CESSION_OVERTURNING_LABELS,
  type CessionStatus,
  getCessionStatusColorClass,
} from '~/constants/capitalMarkets';

import type { FinancingDetailData } from '../types/financingDetail.types';

import { getCategoryLabel, getStatusLabel } from '../hooks/useCessionLabels';

interface Props {
  formatDate: (_dateString?: string) => string;
  operations: FinancingDetailData['operations_history'];
}

defineProps<Props>();
const router = useRouter();

function handleCessionClick(cessionId?: number): void {
  if (cessionId) {
    router.push(`/cessions/${cessionId}`);
  }
}
</script>

<template>
  <div class="table-responsive">
    <table class="table table-vcenter card-table">
      <thead>
        <tr>
          <th scope="col">{{ CESSION_OVERTURNING_LABELS.UPDATED_AT }}</th>
          <th scope="col">{{ CESSION_OVERTURNING_LABELS.ID_CESSION }}</th>
          <th scope="col">{{ CESSION_OVERTURNING_LABELS.CATEGORY }}</th>
          <th scope="col">{{ CESSION_OVERTURNING_LABELS.STATUS }}</th>
          <th scope="col">{{ CESSION_OVERTURNING_LABELS.SECURITIZATION_ORIGIN }}</th>
          <th scope="col">{{ CESSION_OVERTURNING_LABELS.SECURITIZATION_TARGET }}</th>
          <th scope="col">{{ CESSION_OVERTURNING_LABELS.INTERMEDIATOR }}</th>
          <th scope="col">{{ CESSION_OVERTURNING_LABELS.DATE_CESSION }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in operations"
          :key="item.cession_id || item.cession_financing_id"
          class="cursor-pointer"
          @click="handleCessionClick(item.cession_id)"
        >
          <td>{{ formatDate(item.updated_at) }}</td>
          <td>{{ item.cession_id }}</td>
          <td>
            <span class="tag">
              <span
                class="badge badge-3 text-white tag-status badge-dot"
                :class="`bg-${
                  CESSION_CATEGORY_COLOR_CLASS[
                    item.category as keyof typeof CESSION_CATEGORY_COLOR_CLASS
                  ]
                }`"
              />
              {{ getCategoryLabel(item.category) }}
            </span>
          </td>
          <td class="text-nowrap">
            <span
              class="badge"
              :class="`bg-${getCessionStatusColorClass(item.status as CessionStatus)}-lt`"
            >
              {{ getStatusLabel(item.status) }}
            </span>
          </td>
          <td>{{ item.securitization_origin }}</td>
          <td>{{ item.securitization_target }}</td>
          <td>
            <strong>{{ item.intermediator }}</strong>
          </td>
          <td>{{ formatDate(item.ceded_at) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
